import { useLocation, useNavigate } from 'react-router-dom'
import PodcastCard from '@presentation/components/ui/PodcastCard'
import LoadingSpinner from '@presentation/components/ui/LoadingSpinner'
import { usePodcasts } from '@presentation/hooks/usePodcasts'
import { useScrollToTopOnRouteEnter } from '@presentation/hooks/useScrollToTopOnRouteEnter'
import SeoHead from '@presentation/seo/SeoHead'

export default function PodcastListPage() {
  const location = useLocation()
  const navigate = useNavigate()
  const isPodcastListRoute = location.pathname === '/prof-bas-bloem-weekly'
  useScrollToTopOnRouteEnter({ enabled: isPodcastListRoute })
  const {
    episodes,
    loading,
    loadingMore,
    error,
    hasMore,
    loadMore,
  } = usePodcasts()
  const navigateBackToHome = () => {
    if (window.history.length > 1) {
      navigate(-1)
      return
    }

    navigate('/', { replace: true })
  }

  return (
    <div className="bg-background pb-8 pt-3 sm:pb-12 sm:pt-4">
      {isPodcastListRoute ? (
        <SeoHead
          title="Prof Bas Bloem Weekly Podcast | Parkinson's Insights"
          description="Listen to Parkinson's podcast episodes from Prof Bas Bloem Weekly and explore practical guidance from experts."
          canonicalPath="/prof-bas-bloem-weekly"
        />
      ) : null}
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <button
          type="button"
          onClick={navigateBackToHome}
          className="inline-flex items-center gap-1 text-sm font-semibold text-primary no-underline hover:text-primary-light md:hidden"
        >
          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Back to Home
        </button>

        <div className="mt-5 ml-1 flex items-center justify-between gap-3 pl-1 sm:mt-6 sm:ml-2 sm:pl-2">
          <h1 className="text-3xl font-bold tracking-tight text-black sm:text-4xl">
            Prof Bas Bloem Weekly
          </h1>
        </div>

        {loading ? (
          <LoadingSpinner className="mt-8" />
        ) : error ? (
          <p className="mt-8 text-center text-text-secondary">
            Unable to load podcasts. Please try again later.
          </p>
        ) : episodes.length === 0 ? (
          <div className="mt-12 text-center">
            <p className="text-lg font-semibold text-text-secondary">
              No podcast episodes available.
            </p>
          </div>
        ) : (
          <>
            <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {episodes.map((episode) => (
                <PodcastCard key={episode.uid} episode={episode} />
              ))}
            </div>

            {hasMore ? (
              <div className="mt-8 flex justify-center">
                <button
                  type="button"
                  onClick={() => {
                    void loadMore()
                  }}
                  disabled={loadingMore}
                  className="inline-flex rounded-lg bg-blue px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-blue/90 disabled:cursor-not-allowed disabled:opacity-60"
                >
                  {loadingMore ? 'Loading...' : 'Load more'}
                </button>
              </div>
            ) : null}
          </>
        )}
      </div>
    </div>
  )
}
